import { InboxOutlined } from '@ant-design/icons';
import { Space, Typography, UploadProps } from 'antd';
import { PageHeader } from "@ant-design/pro-layout";
import { message, Upload } from 'antd';
import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { importMeltable } from 'services';

const { Dragger } = Upload;

const Meltable: React.FC = () => {
  const [total, setTotal] = useState(0)

  const props: UploadProps = {
    name: 'file',
    customRequest: (options: any) => {
      const data= new FormData()
      data.append('file', options.file)
      importMeltable(data).then((res: any) => {
        setTotal(res.data.total)
        options.onSuccess(res.data, options.file)
      }).catch((err: Error) => {
        console.log(err)
        options.onError(err, options.file)
      })
    },
    onChange(info) {
      const { status } = info.file;
      if (status !== 'uploading') {
        console.log(info.file, info.fileList);
      }
      if (status === 'done') {
        message.success(`${info.file.name} file uploaded successfully.`);
      } else if (status === 'error') {
        message.error(`${info.file.name} file upload failed.`);
      }
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };

  return (
    <>
      <Helmet>
        <title>Meltable | Admin UI</title>
      </Helmet>
      <PageHeader
        className="page-header"
        title="Meltable"
        footer={
          <Space
            direction="vertical"
            align="center"
            size="large"
            style={{ width: '100%', paddingBottom: 50, justifyContent: 'center' }}
          >
            <Space direction="vertical" style={{ width: 500, alignSelf: 'start' }}>
              <Typography><strong>Total of Uploaded ASINs: </strong>{total}</Typography>
              <Dragger {...props}>
                <p className="ant-upload-drag-icon">
                  <InboxOutlined />
                </p>
                <p className="ant-upload-text">Click or drag .CSV, .XLS or .XLSX file to this area to upload</p>
              </Dragger>
            </Space>
          </Space>
        }
      />
    </>
  );
}

export default Meltable;